import { createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useContext, useEffect, useState } from 'react'

import { useMeLazyQuery } from '../graphql'

type ContextProps = {
  token: string
  setToken: Dispatch<SetStateAction<string>>
  user: { username: string; id: string } | null
  setUser: Dispatch<SetStateAction<{ username: string; id: string } | null>>
}

const Context = createContext<ContextProps>({ user: null, setUser: () => null, token: '', setToken: () => null })

const Auth: FC<PropsWithChildren> = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token') || '')
  const [user, setUser] = useState<ContextProps['user']>(null)

  return <Context.Provider value={{ user, setUser, token, setToken }}>{children}</Context.Provider>
}

const Me: FC<PropsWithChildren> = ({ children }) => {
  const [me] = useMeLazyQuery()

  const { token, setToken, setUser } = useContext(Context)
  useEffect(() => {
    if (token) {
      me().then((response) => {
        if (response.data?.me) {
          setUser(response.data?.me)
        } else {
          setToken('')
          localStorage.removeItem('token')
          setUser(null)
        }
      })
    }
  }, [token, me, setUser, setToken])

  return children
}

export { Context, Me }

export default Auth
